import { timeZonelist } from '@/utils/zonasHorarias.js'
export default {
  negociosGestArray: [],
  negocioGest: null,
  loadingNegocioGest: false,
  negocioObjGest: null, //para admin, boss_restaurante y boss_negocio guarda los datos del negocio
  directorioGest: null,
  directorioObjGest: { //para boss_directorio y admin
    nombre: '',
    negocios: []
  },
  restauranteGest: null, //array si es boss_restaurante
  partner: { id: null, nombre: '' }, //usuario partner. indica el tipo de partner que es
  partnerNegocios: [], //usuario partner.
  partnerNegociosObj: [], //usuario partner.
  restaurantesArray: [],
  negocioFiltrarRestaurante: null, //para mostrar los restaurantes de un negocio elegido
  zonasHorarias: timeZonelist,
  modoDesarrollo: 'desarrollo', // desarrollo o produccion'
  arrayTiempoReal: [],
  dashboardConfig: null,
  clientesFacturar: [],
  statusCuentas: []
}
